import React, { useMemo } from 'react';
import qrcode from 'qrcode-generator';
import { View } from './rn';

// 9.34.3.2 / D-696 — güvenlik numarasının QR kodu. Çizim için yerel modül yok:
// kodlayıcı saf JavaScript, kareler sıradan View. Böylece yeni bir uygulama
// sürümü gerekmeden gelir. Aynı renkteki ardışık kareler tek View'de birleşiyor;
// 37×37'lik bir kodda bin küsur kare yerine birkaç yüz parça çiziliyor.

/** QR kodunun kare matrisi: `true` koyu. Okuyucu için orta düzey hata düzeltmesi. */
export function qrMatrix(text: string): boolean[][] {
  const qr = qrcode(0, 'M');
  qr.addData(text, 'Byte');
  qr.make();
  const n = qr.getModuleCount();
  return Array.from({ length: n }, (_, row) => Array.from({ length: n }, (_c, col) => qr.isDark(row, col)));
}

/** Bir satırı aynı renkli parçalara böler: [koyu mu, uzunluk]. */
export function runs(row: boolean[]): Array<[boolean, number]> {
  const out: Array<[boolean, number]> = [];
  for (const dark of row) {
    const last = out[out.length - 1];
    if (last && last[0] === dark) last[1] += 1;
    else out.push([dark, 1]);
  }
  return out;
}

const QUIET = 4; // QR standardının istediği boş kenar, kare cinsinden.

type Props = { value: string; size: number; accessibilityLabel: string; testID?: string };

export default function SafetyQrCode({ value, size, accessibilityLabel, testID }: Props) {
  const matrix = useMemo(() => qrMatrix(value), [value]);
  const cell = Math.max(1, Math.floor(size / (matrix.length + QUIET * 2)));
  // Okuyucular koyu kareyi açık zeminde bekler; koyu temada da renkler sabit.
  return (
    <View
      testID={testID}
      accessible
      accessibilityRole="image"
      accessibilityLabel={accessibilityLabel}
      style={{ backgroundColor: '#FFFFFF', padding: cell * QUIET, alignSelf: 'center' }}>
      {matrix.map((row, r) => (
        <View key={r} style={{ flexDirection: 'row', height: cell }}>
          {runs(row).map(([dark, length], i) => (
            <View key={i} style={{ width: cell * length, height: cell, backgroundColor: dark ? '#000000' : '#FFFFFF' }} />
          ))}
        </View>
      ))}
    </View>
  );
}
